export default {
    message: 'The {_field_} value must be a valid number.',
    validate: (value) => {
        let regex = new RegExp('^([\-0-9\.]+)$');
        return regex.test(value);
    }
}
